import { default as CloseIcon } from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Card,
  CardContent,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridToolbarContainer
} from "@mui/x-data-grid";
import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Swal from "sweetalert2";
import "./Index.css";
import dayjs from "dayjs";
import { TimeField } from "@mui/x-date-pickers/TimeField";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ExerciseOptions, ProgramOptions, ScheduleOptions } from "./RepsAndSetsResources.js";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});

const EquipmentsDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            {details.map((equipment, index) => (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img src={`${apiBaseURL}${equipment.icon}`} height="25" width="25" />
                <Typography key={index} component="div">
                  {equipment.name}
                </Typography>
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

const ExercisesDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        <Card sx={{ maxHeight: "70vh", overflowY: "auto" }}>
          <CardContent>
            {details.map((exercise, index) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column"
                }}
              >
                <Box>
                  <Box>{exercise.name}</Box>
                  <Box></Box>
                </Box>
                <ReactPlayer
                  url={`${apiBaseURL}${exercise.gif}`}
                  playing={true}
                  loop={true}
                  controls={true}
                  height={320}
                  width="100%"
                  style={{ borderRadius: "30px", overflow: "hidden" }}
                />
              </Box>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

const appColor = "#59D6DF";
const initialRows = [];
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

const countSeconds = (date) => {
  return dayjs(date).minute() * 60 + dayjs(date).second();
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};

function EditToolbar(props) {
  const {
    setRows,
    setRowModesModel,
    addedUser,
    setAddedUser,
    showToolbar,
    setShowToolbar,
    selectedSchedule,
    setSelectedSchedule
  } = props;
  const [open, setOpen] = React.useState(false);
  const [id, setId] = useState("");
  const [programOptions, setProgramOptions] = useState([]);
  const [selectProgram, setSelectProgram] = useState("");
  const [exerciseOptions, setExerciseOptions] = useState([]);
  const [selectExercise, setSelectExercise] = useState([]);
  const [selectDays, setSelectDays] = useState([]);
  const [daysOption, setDaysOptions] = useState([]);
  const [sets, setSets] = useState("");
  const [reps, setReps] = useState("");
  const [time, setTime] = useState(0);
  const [defaultTime, setDefaultTime] = useState(dayjs("00:00", "mm:ss"));
  const [exerciseInputType, setExerciseInputType] = useState(""); // "reps" or "time"
  const [clickedClosed, setClickClosed] = useState(false);

  const [programError, setProgramError] = useState("");
  const [daysError, setDaysError] = useState("");
  const [exerciseError, setExerciseError] = useState("");
  const [setsError, setSetsError] = useState("");
  const [repsError, setRepsError] = useState("");
  const [timeError, setTimeError] = useState("");

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setId("");
    setShowToolbar(false);
    setSelectedSchedule({});
    setClickClosed(!clickedClosed);
    setSelectProgram("");
    setExerciseOptions([]);
    setProgramOptions([]);
    setDaysOptions([]);
    setSelectDays([]);
    setSelectExercise([]);
    setReps("");
    setSets("");
    setTime(0);
    setDefaultTime(dayjs("00:00", "mm:ss"));
    setExerciseInputType("");
  };

  useEffect(() => {
    ProgramOptions().then((value) => {
      setProgramOptions(value);
    });
    ExerciseOptions().then((value) => {
      setExerciseOptions(value);
    });
    setOpen(showToolbar);
    if (Object.keys(selectedSchedule).length) {
      setId(selectedSchedule._id || "");
      setSelectProgram(selectedSchedule.programId);
      setSelectExercise([selectedSchedule.exerciseId]);
      ScheduleOptions().then((value) => {
        const scheduleArr = value;
        const daysOptions = scheduleArr
          .filter((value) => {
            const isFoundProgram = value.programId._id == selectedSchedule.programId;
            const isFoundExercise = value.exercises.find(
              (value) => value.exerciseId == selectedSchedule.exerciseId
            );
            if (isFoundExercise && isFoundProgram) {
              return true;
            }
          })
          .map((value) => {
            return value.day;
          });
        setDaysOptions(daysOptions);
      });
      setSelectDays([selectedSchedule.day]);
      setSets(selectedSchedule.sets);
      setReps(selectedSchedule.reps || "");
      setTime(selectedSchedule.timeInSeconds || 0);

      // Set exercise input type based on existing data
      if (selectedSchedule.reps && selectedSchedule.reps !== null && selectedSchedule.reps !== "" && selectedSchedule.reps !== "-") {
        setExerciseInputType("reps");
      } else if (selectedSchedule.timeInSeconds && selectedSchedule.timeInSeconds > 0) {
        setExerciseInputType("time");
        setDefaultTime(dayjs(`${selectedSchedule.time}`, "mm:ss"));
      }
    } else {
      setId("");
      setSelectProgram("");
      setDaysOptions([]);
      setSelectDays([]);
      setSelectExercise([]);
      setReps("");
      setSets("");
      setTime(0);
      setDefaultTime(dayjs("00:00", "mm:ss"));
      setExerciseInputType("");
    }
  }, [showToolbar, selectedSchedule]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectDays.length) {
      setDaysError("Please select days to modify the sets and reps!");
      return;
    } else if (sets == "" || !sets || sets < 0) {
      setSetsError("Please add the valid sets.");
      return;
    } else if (exerciseInputType === "reps" && (reps == "" || !reps || reps < 0)) {
      setRepsError("Please add the valid repetitions.");
      return;
    } else if (exerciseInputType === "time" && (!time || time <= 0)) {
      setTimeError("Please add the valid time.");
      return;
    } else {
      const headers = {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("token")}`
      };
      axios
        .post(
          `${apiBaseURL}/api/v1/admin/updatesetsandreps`,
          {
            selectProgram,
            selectDays,
            selectExercise,
            sets,
            reps: exerciseInputType === "reps" ? reps : null,
            time: exerciseInputType === "time" ? time : null
          },
          {
            headers: headers
          }
        )
        .then((res) => {
          if (res.data) {
            setOpen(false);
            setShowToolbar(false);
            setAddedUser(!addedUser);
            setSelectedSchedule({});
            const { message } = res.data;
            Swal.fire({
              position: "center",
              icon: "success",
              title: `${message}`,
              showConfirmButton: false,
              timer: 1000
            });
          }
        })
        .catch((error) => {
          setOpen(false);
          setShowToolbar(false);
          setAddedUser(!addedUser);
          setSelectedSchedule({});
          const { message } = error.response.data;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: message
          });
        });
    }
  };

  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 5,
                top: 5,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Program</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    fullWidth
                    value={selectProgram}
                    defaultValue={selectProgram}
                    label="Program"
                    sx={{ height: "45px" }}
                  >
                    {programOptions.map((option) => (
                      <MenuItem sx={{ height: "45px" }} key={option.id} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{programError}</InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Exercise</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    multiple
                    fullWidth
                    value={selectExercise}
                    input={<OutlinedInput label="Exercise" />}
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const option = exerciseOptions.find((opt) => opt.id === value);
                          return option ? option.name : value;
                        })
                        .join(", ")
                    }
                    sx={{ height: "45px" }}
                    MenuProps={MenuProps}
                  >
                    {exerciseOptions.map((option) => (
                      <MenuItem key={option.name} value={option.id}>
                        <Checkbox checked={selectExercise.indexOf(option.id) > -1} />
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{exerciseError}</InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-checkbox-label">Select Days</InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    multiple
                    fullWidth
                    value={selectDays}
                    input={<OutlinedInput label="Select Days" />}
                    onChange={(event) => {
                      setSelectDays(event.target.value);
                    }}
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const option = exerciseOptions.find((opt) => opt === value);
                          return option ? option : value;
                        })
                        .join(", ")
                    }
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                    MenuProps={MenuProps}
                  >
                    {daysOption.map((option) => (
                      <MenuItem key={option} value={option}>
                        <Checkbox checked={selectDays.indexOf(option) > -1} />
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{daysError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Sets(In digits only)"
                  name="sets"
                  type="number"
                  value={sets}
                  onChange={(event) => {
                    setSets(event.target.value);
                    if (!+event.target.value || +event.target.value < 0) {
                      setSetsError("Please add the valid sets.");
                    } else {
                      setSetsError("");
                    }
                  }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{setsError}</InputLabel>
              </Box>
              {exerciseInputType === "reps" && (
                <Box mb={2}>
                  <TextField
                    fullWidth
                    label="Repetitions(In digits only)"
                    type="number"
                    name="fullName"
                    value={reps}
                    onChange={(event) => {
                      setReps(event.target.value);
                      if (!+event.target.value || +event.target.value < 0) {
                        setRepsError("Please add the valid repetitions.");
                      } else {
                        setRepsError("");
                      }
                    }}
                  />
                  <InputLabel sx={{ pt: 1, color: "red" }}>{repsError}</InputLabel>
                </Box>
              )}
              {exerciseInputType === "time" && (
                <Box mb={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["TimeField"]}>
                      <TimeField
                        label="Time(In mm:ss format)"
                        format="mm:ss"
                        error={false}
                        defaultValue={defaultTime}
                        onChange={(newValue) => {
                          if (newValue && dayjs.isDayjs(newValue)) {
                            const seconds = countSeconds(newValue);
                            setTime(seconds);
                            setTimeError("");
                          }
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <InputLabel sx={{ pt: 1, color: "red" }}>{timeError}</InputLabel>
                </Box>
              )}
              <Box mt={4} mb={1}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{
                    backgroundColor: appColor,
                    color: "#FFFFFF",
                    ":hover": {
                      backgroundColor: appColor
                    }
                  }}
                  fullWidth
                >
                  {exerciseInputType === "reps" ? "Update Sets and Reps" : exerciseInputType === "time" ? "Update Sets and Time" : "Update Sets"}
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    </GridToolbarContainer>
  );
}

const RepsAndSets = () => {
  const [rows, setRows] = React.useState(initialRows);
  const [addedUser, setAddedUser] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [calledBlockUser, setCallBlockUser] = useState(false);
  const [profilePic, setProfilePic] = React.useState({});
  const [calledUpdateUser, setCallUpdateUser] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenExercise, setModalOpenExercise] = useState(false);
  const [selectedEquipmentsDetails, setSelectedEquipmentsDetails] = useState(null);
  const [selectedExercisesDetails, setSelectedExercisesDetails] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = React.useState({});
  const [showToolbar, setShowToolbar] = React.useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [debouncedSearchBy, setDebouncedSearchBy] = useState("");

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchBy(searchBy);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchBy]);

  // Reset pagination when search changes
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [debouncedSearchBy]);

  const handleOpenModal = (details) => {
    setSelectedEquipmentsDetails(details);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedEquipmentsDetails(null);
    setModalOpen(false);
  };

  const handleOpenModalExercise = (details) => {
    setSelectedExercisesDetails(details);
    setModalOpenExercise(true);
  };

  const handleCloseModalExercise = () => {
    setSelectedExercisesDetails(null);
    setModalOpenExercise(false);
  };

  function formatIdealTime(idealTime) {
    if (!idealTime) return "0 mins";

    const timeInSeconds = parseInt(idealTime, 10);
    if (isNaN(timeInSeconds) || timeInSeconds <= 0) return "0 mins";

    const minutes = Math.floor(timeInSeconds / 60);
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    if (hours > 0 && remainingMinutes > 0) {
      return `${hours} hrs ${remainingMinutes} mins`;
    } else if (hours > 0) {
      return `${hours} hrs`;
    } else {
      return `${minutes} mins`;
    }
  }

  const secondToMMSS = (given_seconds) => {
    if (!given_seconds || given_seconds === 0) return null;
    const dateObj = new Date(given_seconds * 1000);
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getSeconds();
    const timeString =
      minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
    return timeString;
  };


  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };
        const exerciseList = await axios.post(
          `${apiBaseURL}/api/v1/admin/getsetsandreps`,
          {
            searchBy: debouncedSearchBy,
            page: paginationModel.page + 1, // API expects 1-based page numbers
            pageSize: paginationModel.pageSize
          },
          {
            headers: headers
          }
        );
        if (exerciseList.data) {
          const { allSetsAndReps, total, currentPage, totalPages } = exerciseList.data.data;
          const currentRows = allSetsAndReps.map((value, index) => {
            return {
              id: index + 1,
              _id: value._id,
              name: value?.exerciseName,
              day: value?.day,
              exerciseId: value?.exerciseId,
              programName: value?.programName,
              programId: value?.programId,
              sets: value?.sets,
              reps: value?.reps,
              time: value?.time ? secondToMMSS(value?.time) : null,
              timeInSeconds: value?.time || 0
            };
          });
          setRows(currentRows);
          setTotalRows(total || allSetsAndReps.length);
        }
      } catch (error) {
        console.error("Error fetching sets and reps:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch sets and reps. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [
    addedUser,
    calledBlockUser,
    calledUpdateUser,
    debouncedSearchBy,
    paginationModel.page,
    paginationModel.pageSize
  ]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleFileChange = (e, params) => {
    const file = e.target.files[0];
    if (file) {
      const updatedRow = {
        ...params.row,
        // profilePic: `<img src="${URL.createObjectURL(file)}" />`,?
        profilePic: file
      };
      setProfilePic(updatedRow.profilePic);
      setRows((prevRows) => prevRows.map((row) => (row.id === params.id ? updatedRow : row)));
    }
  };

  const columns = [
    { field: "name", headerName: "Exercise Name", width: 200, sortable: false },
    {
      field: "day",
      headerName: "Day",
      type: "number",
      width: 100,
      sortable: false
    },
    {
      field: "programName",
      headerName: "Program Name",
      width: 220,
      sortable: false
    },
    {
      field: "sets",
      headerName: "Sets",
      width: 120,
      sortable: false
    },
    {
      field: "reps",
      headerName: "Reps",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return params.value !== null && params.value !== undefined && params.value !== ""
          ? params.value
          : "-";
      }
    },
    {
      field: "time",
      headerName: "Time",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return params.value !== null && params.value !== undefined && params.value !== ""
          ? params.value
          : "-";
      }
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      sortable: false,
      width: 150,
      cellClassName: "actions",
      getActions: (params) => {
        const id = params.row.id;
        // if (isInEditMode) {
        //   return [
        //     <GridActionsCellItem
        //       icon={<SaveIcon />}
        //       label="Save"
        //       sx={{
        //         color: "primary.main"
        //       }}
        //       onClick={() => {
        //         handleSaveClick(id);
        //       }}
        //     />,
        //     <GridActionsCellItem
        //       icon={<CancelIcon />}
        //       label="Cancel"
        //       className="textPrimary"
        //       onClick={() => {
        //         handleCancelClick(id);
        //       }}
        //       color="inherit"
        //     />
        //   ];
        // }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => {
              setShowToolbar(true);
              setSelectedSchedule(params.row);
            }}
            color="inherit"
          />
          // <GridActionsCellItem
          //   icon={<DeleteIcon />}
          //   label="Delete"
          //   onClick={() => {
          //     handleDeleteClick(id);
          //   }}
          //   color="inherit"
          // />
        ];
      }
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ width: "100%", marginBottom: 2 }}>
        <TextField
          id="outlined-basic"
          label="Search by Exercise Name or Day"
          variant="outlined"
          value={searchBy}
          onChange={(event) => {
            setSearchBy(event.target.value);
          }}
          sx={{
            width: "300px"
          }}
        />
      </Box>
      <Box
        sx={{
          height: 675,
          width: "100%",
          "& .actions": {
            color: "text.secondary"
          },
          "& .textPrimary": {
            color: "text.primary"
          }
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnResize
          disableColumnMenu
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          slots={{
            toolbar: EditToolbar
          }}
          // Server-side pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalRows}
          pageSizeOptions={[10, 20, 30, 50]}
          loading={loading}
          sx={{
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontWeight: 400,
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              "&:nth-of-type(odd)": {
                backgroundColor: "#f9f9f9"
              }
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-row:focus": {
              outline: "none"
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none"
            },
            "& .Mui-selected": {
              backgroundColor: "inherit !important"
            },
            "& .MuiDataGrid-columnHeader": {
              "& .MuiDataGrid-iconButtonContainer": {
                display: "none"
              },
              "& .MuiDataGrid-menuIcon": {
                display: "none"
              }
            }
          }}
          localeText={{ noRowsLabel: "No Exercise is available" }}
          slotProps={{
            toolbar: {
              setRows,
              setRowModesModel,
              addedUser,
              setAddedUser,
              showToolbar,
              setShowToolbar,
              selectedSchedule,
              setSelectedSchedule
            }
          }}
        />
        <ExercisesDetailsModal
          open={modalOpenExercise}
          onClose={handleCloseModalExercise}
          details={selectedExercisesDetails}
        />
        <EquipmentsDetailsModal
          open={modalOpen}
          onClose={handleCloseModal}
          details={selectedEquipmentsDetails}
        />
      </Box>
    </DashboardLayout>
  );
};

export default RepsAndSets;
